"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBoxTabsRearrangePage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const molecules_1 = require("../../molecules");
const i18n_1 = require("@completeanatomy/i18n");
function InfoBoxTabsRearrangePage({ onBack, }) {
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'InfoBoxTabsRearrangePage_Container', children: [(0, jsx_runtime_1.jsx)(ui_1.Header, { type: ui_1.HeaderType.WithBackButton, backButton: {
                    onClick: onBack,
                    label: (0, i18n_1.Localized)(i18n_1.Strings.header.back),
                }, "data-e2e": 'InfoBoxTabsRearrangePage_Header', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.displayOrderShort) }), (0, jsx_runtime_1.jsxs)(StyledSection, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.displayOrder), "data-e2e": 'InfoBoxTabsRearrangePage_StyledSection', children: [(0, jsx_runtime_1.jsx)(molecules_1.DnDHint, { "data-e2e": 'InfoBoxTabsRearrangePage_DnDHint' }), (0, jsx_runtime_1.jsx)(StyledInfoBoxTabsOrder, { "data-e2e": 'InfoBoxTabsRearrangePage_StyledInfoBoxTabsOrder' })] })] }));
}
exports.InfoBoxTabsRearrangePage = InfoBoxTabsRearrangePage;
const Container = styled_components_1.default.div `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;

  display: flex;
  flex-direction: column;
  align-items: center;

  overflow-y: scroll;

  background-color: ${({ theme }) => theme.designSystem.background};
`;
const StyledSection = (0, styled_components_1.default)(molecules_1.PreferencesSection) `
  padding: 30px calc(24px + env(safe-area-inset-left));
  padding: 30px calc(24px + constant(safe-area-inset-left));
`;
const StyledInfoBoxTabsOrder = (0, styled_components_1.default)(molecules_1.InfoBoxTabsOrder) `
  justify-content: center;

  width: 100%;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    justify-content: unset;
  `)}
`;
